import { gql } from '@apollo/client';

export const resetChargerForExtend = gql`
  mutation resetChargerForExtend($chargerInput: ResetChargerForExtendInput!) {
    resetChargerForExtend(input: $chargerInput)
  }
`;
